import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Fab, FormControl, Grid, InputLabel, ListSubheader, MenuItem, Select, TextField, Tooltip, Typography } from '@mui/material'
import React, { FC, useEffect, useState } from 'react'
import { Flex } from '../../../components/common/Helpers'
import NoteAddIcon from '@mui/icons-material/NoteAdd'
import SaveIcon from '@mui/icons-material/Save'
import { MaterialType, materialTypeValues } from '../../../api/appAPI'
import { AvailableMaterialsForFM } from '../../../redux/itemReducer'
import emptyMaterial from '../../../assets/emptyMaterial.png'

type TextfieldProps = {
    value: string,
    onChange(event: React.ChangeEvent<{ value: string }>): void
}

interface IProps {
    materials: AvailableMaterialsForFM

    title: string

    name: TextfieldProps
    sku: TextfieldProps
    materialId: {
        value: number,
        onChange: (v: number) => void
    }
    floorSetupCharge: TextfieldProps
    floorPricePerSqFt: TextfieldProps
    curbSetupCharge: TextfieldProps
    curbPricePerSqFt: TextfieldProps
    curbLinearPricePerFt: TextfieldProps
    shortDescription: TextfieldProps
    longDescription: TextfieldProps
    pictureUrl: TextfieldProps
    pdfUrl: TextfieldProps

    button: {
        text: string,
        onClick(): void
    }

    needSave?: boolean

}

const FloorMaterialUIBox: FC<IProps> = props => {
    // @ts-ignore
    const [selectedMaterial, setSelectedMaterial] = useState({ name: '', src: '' })

    useEffect(() => {
        // @ts-ignore 2D array -> array
        const materials = [].concat(...props.materials.map(_ => _.materials)) as MaterialType[]

        const material = materials.find(m => m.id === props.materialId.value)

        if (material) {
            setSelectedMaterial({ name: material.name, src: material.texture.texture?.image.cloneNode().src || '' })
        }
    }, [props.materialId.value])

    return (
        <Box
            display='flex'
            flexDirection='column'
            alignItems='center'
            pb={2}
            style={{
                width: 400,
                height: 'fit-content',
                margin: 15,
                border: '1px solid black',
                maxHeight: '90%',
                overflowY: 'auto',
                overflowX: 'hidden',
                position: 'relative'
            }}
        >
            <Box
                py={1}
                style={{
                    position: 'sticky',
                    top: 0,
                    width: '100%',
                    backgroundColor: 'white',
                    zIndex: 10
                }}>
                <Grid container spacing={2}>
                    <Grid item xs={3}> </Grid>
                    <Grid item xs={6} container justifyContent='center' alignItems='center'>
                        <Typography variant='h6'>{props.title}</Typography>
                    </Grid>
                    <Grid item xs={3} container justifyContent='flex-end' alignItems='center'>
                        <Tooltip title={props.title === 'New Floor Material' ? 'Create' : 'Save'}>
                            <Fab
                                color={props.needSave ? 'secondary' : "primary"}
                                size='small'
                                onClick={props.button.onClick}
                                style={{ marginRight: 10 }}
                            >
                                {props.title === 'New Part' ? <NoteAddIcon /> : <SaveIcon />}
                            </Fab>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Box>


            <Box
                display='flex'
                flexDirection='column'
                alignItems='center'
                pb={2}
                style={{
                    width: 400,
                    height: 'fit-content',
                    // margin: 15,
                    // border: '1px solid black',
                    maxHeight: '90%',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    position: 'relative'
                }}
            >

                {/* <Box
                        py={1}
                        style={{
                            position: 'sticky',
                            top: 0,
                            width: '100%',
                            backgroundColor: 'white',
                            zIndex: 10
                        }}>
                        <Grid container spacing={2}>
                            <Grid item xs={3}> </Grid>
                            <Grid item xs={6} container justifyContent='center' alignItems='center'>
                                <Typography variant='h6'>{props.title}</Typography>
                            </Grid>
                            <Grid item xs={3} container justifyContent='flex-end' alignItems='center'>
                                <Tooltip title={props.title === 'New Costumer' ? 'Create' : 'Save'}>
                                    <Fab
                                        color={props.needSave ? 'secondary' : "primary"}
                                        size='small'
                                        onClick={props.button.onClick}
                                        style={{ marginRight: 10 }}
                                    >
                                        {props.title === 'New Costumer' ? <NoteAddIcon /> : <SaveIcon />}
                                    </Fab>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Box> */}


                <Flex column sx={{ px: 4, pt: 2, gap: 2 }}>


                    <TextField
                        label="Name"
                        variant="outlined"
                        value={props.name.value}
                        onChange={props.name.onChange}
                    />
                    <TextField
                        label="Product SKU"
                        variant="outlined"
                        value={props.sku.value}
                        onChange={props.sku.onChange}
                    />

                    <Flex centerY gap={1} sx={{ maxWidth: 223 }}>
                        <Box sx={{
                            minWidth: 56,
                            height: 56
                        }}>
                            <img
                                width={56}
                                src={selectedMaterial.src}
                                alt="preview"
                                onError={() => { setSelectedMaterial({ name: '', src: emptyMaterial }) }}
                            />
                        </Box>

                        <FormControl
                            variant="outlined"
                            sx={{ flexGrow: 1 }}
                        >
                            <InputLabel>Select material</InputLabel>
                            <Select
                                value={selectedMaterial}
                                renderValue={v => {
                                    return v.name
                                }}
                                label="Select material"
                            >
                                {
                                    props.materials.map(obj => {
                                        return <Box key={obj.distributor}>
                                            <ListSubheader>{obj.distributor}</ListSubheader>
                                            {
                                                obj.materials.map(m =>
                                                    <MenuItem key={m.id}
                                                        onClick={() => {
                                                            props.materialId.onChange(m.id)
                                                        }}
                                                    >{m.name}</MenuItem>)
                                            }
                                        </Box>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </Flex>

                    {/* <TextField
                        label="Picture URL"
                        variant="outlined"
                        value={props.pictureUrl.value}
                        onChange={props.pictureUrl.onChange}
                    /> */}

                    <TextField
                        label="Short Description"
                        variant="outlined"
                        value={props.shortDescription.value}
                        onChange={props.shortDescription.onChange}
                    />
                    <TextField
                        label="Long Description"
                        variant="outlined"
                        value={props.longDescription.value}
                        onChange={props.longDescription.onChange}
                        multiline
                    />

                    <TextField
                        label="PDF URL"
                        variant="outlined"
                        value={props.pdfUrl.value}
                        onChange={props.pdfUrl.onChange}
                    />

                    <TextField
                        label="Floor Setup Charge"
                        variant="outlined"
                        type='number'
                        value={props.floorSetupCharge.value}
                        onChange={props.floorSetupCharge.onChange}
                        sx={{ width: 1 }}
                        required
                    />

                    <TextField
                        label="Floor Price Per Sq. Ft"
                        variant="outlined"
                        type='number'
                        value={props.floorPricePerSqFt.value}
                        onChange={props.floorPricePerSqFt.onChange}
                        sx={{ width: 1 }}
                        required
                    />
                    <TextField
                        label="Curb Setup Charge"
                        variant="outlined"
                        type='number'
                        value={props.curbSetupCharge.value}
                        onChange={props.curbSetupCharge.onChange}
                        sx={{ width: 1 }}
                        required
                    />
                    <TextField
                        label="Curb Price Per Sq. Ft"
                        variant="outlined"
                        type='number'
                        value={props.curbPricePerSqFt.value}
                        onChange={props.curbPricePerSqFt.onChange}
                        sx={{ width: 1 }}
                        required
                    />
                    <TextField
                        label="Curb Lineal Price Per Ft"
                        variant="outlined"
                        type='number'
                        value={props.curbLinearPricePerFt.value}
                        onChange={props.curbLinearPricePerFt.onChange}
                        sx={{ width: 1 }}
                        required
                    />




                </Flex>

            </Box >
            {/* </DialogContent>
            <DialogActions>
                <Button
                    variant='contained'
                    color={props.needSave ? 'secondary' : "primary"}
                    onClick={props.button.onClick}

                >{props.title === 'New Floor Material' ? 'Create' : 'Save'}</Button>
            </DialogActions> */}
            {/* </Dialog> */}
        </Box>

    )
}

export default FloorMaterialUIBox